import { useEffect } from 'react';

const SEO = ({
  title,
  description,
  canonicalPath,
  noindex = false
}) => {
  useEffect(() => {
    // 1. Update title
    const fullTitle = title
      ? `${title} | Sunshine Travels`
      : 'Sunshine Travels | Bespoke Luxury Travel & Holidays';

    document.title = fullTitle;

    // Helper function to update or create meta tags
    const updateMetaTag = (attributeName, attributeValue, content) => {
      if (!content) return;

      let element = document.querySelector(
        `meta[${attributeName}="${attributeValue}"]`
      );

      if (element) {
        element.setAttribute('content', content);
      } else {
        element = document.createElement('meta');
        element.setAttribute(attributeName, attributeValue);
        element.setAttribute('content', content);
        document.head.appendChild(element);
      }
    };

    // 2. Update description
    updateMetaTag('name', 'description', description);

    // 3. Update Open Graph tags
    updateMetaTag('property', 'og:title', fullTitle);
    updateMetaTag('property', 'og:description', description);

    const currentUrl = `https://sunshinemanipal.com${canonicalPath || ''}`;

    updateMetaTag('property', 'og:url', currentUrl);

    // 4. Update Twitter Card tags
    updateMetaTag('property', 'twitter:title', fullTitle);
    updateMetaTag('property', 'twitter:description', description);
    updateMetaTag('property', 'twitter:url', currentUrl);

    // 5. Update Canonical link
    let canonicalLink = document.querySelector('link[rel="canonical"]');

    if (canonicalLink) {
      canonicalLink.setAttribute('href', currentUrl);
    } else {
      canonicalLink = document.createElement('link');
      canonicalLink.setAttribute('rel', 'canonical');
      canonicalLink.setAttribute('href', currentUrl);
      document.head.appendChild(canonicalLink);
    }

    // 6. Handle robots noindex
    let robotsMeta = document.querySelector('meta[name="robots"]');

    if (noindex) {
      if (!robotsMeta) {
        robotsMeta = document.createElement('meta');
        robotsMeta.setAttribute('name', 'robots');
        document.head.appendChild(robotsMeta);
      }

      robotsMeta.setAttribute('content', 'noindex,follow');
    } else {
      if (robotsMeta) {
        robotsMeta.remove();
      }
    }
  }, [title, description, canonicalPath, noindex]);

  return null;
};

export default SEO;